import type { FilterFormValues, TEventReferencePreview } from '@vlabs/monokit/entities/matcher/types/types';
import { Page } from '@vlabs/monokit/shared/ui/page/Page.js';
import { PageContent } from '@vlabs/monokit/shared/ui/page/PageContent.js';
import { PageHeader } from '@vlabs/monokit/shared/ui/page/PageHeader.js';
import { useWindowSize } from '@vlabs/uikit';
import cn from 'classnames';
import { useForm, FormProvider } from 'react-hook-form';

import type { EventCard } from '@vlabs/monokit/shared/ui/event-card/';

import st from './SearchPageView.module.sass';
import { useSearchPageTranslation } from '../i18n';
import { defaultFilterValues } from '../model/defaultFormValues';
import { Filters } from './filters/Filters';
import { ReferenceSelector } from './reference-selector/ReferenceSelector.js';
import { Results } from './results/Results';

interface SearchPageViewProps {
  can: (permissions: string[], params?: Record<string, string>) => boolean;
  includedAttributes?: string[];
  maxImageSize?: number | null;
  eventCard?: typeof EventCard;
  eventPreview?: (props: { reference: TEventReferencePreview }) => JSX.Element;
}

function SearchPageView({
  can,
  includedAttributes = [],
  maxImageSize = undefined,
  eventCard = undefined,
  eventPreview = undefined,
}: SearchPageViewProps): JSX.Element {
  const { t } = useSearchPageTranslation();
  const { width } = useWindowSize();
  const formMethods = useForm<FilterFormValues>({
    defaultValues: defaultFilterValues,
    mode: 'onChange',
  });

  return (
    <Page className={cn(st.Page, { [st.Page_small]: width && width < 1920 })}>
      <PageContent className={st.Content}>
        <PageHeader title={t('page.title')} />
        <div className={st.Layout}>
          <ReferenceSelector
            can={can}
            eventPreview={eventPreview}
            maxImageSize={maxImageSize}
          />
          <FormProvider {...formMethods}>
            <Filters
              can={can}
              includedAttributes={includedAttributes}
            />
            <Results eventCard={eventCard} />
          </FormProvider>
        </div>
      </PageContent>
    </Page>
  );
}

export { SearchPageView };
